import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AeAuthService } from '@extranet/services/auth-service';
import { AeStorageService } from '@extranet/services/storage-service';
import { Observable, of } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

@Injectable()
export class IsProspectLogged implements CanActivate {
  constructor(
    private readonly router: Router,
    private aeAuthService: AeAuthService,
    private aeStorageService: AeStorageService
  ) {}

  public canActivate(): Observable<boolean | UrlTree> | UrlTree {
    if (!this.aeAuthService.isLogged) {
      this.aeAuthService.getLoginStorage();
    }
    if (!this.aeAuthService.isLogged) {
      return this.router.createUrlTree(['/auth/login']);
    }
    return this.aeAuthService.renew().pipe(
      map((userData: { data: { jwtToken: string } }): boolean => {
        this.aeStorageService.setStorage('ae-login', { token: userData.data.jwtToken });
        this.aeAuthService.getLoginStorage();
        return true;
      }),
      retry({ count: 3, delay: 500 }),
      catchError(() => {
        this.aeAuthService.logout();
        return of(this.router.createUrlTree(['/auth/login']));
      })
    );
  }
}
